<template>
	<div class="card border-dark mb-3" style="max-width: 30rem;">
		<div class="card-header">{{ account.wallet }}</div>
		<div class="card-body text-dark">
			<h5 class="card-title">Token ID : {{ token.tokenId }}</h5>
			<p class="card-text">Token Balance : {{ token.balance }}</p>
			<p class="card-text">Hbar Balance : {{ token.hbarBalance }}</p>
			<p class="card-text">Kyc Status : {{ token.kycStatus }}</p>
			<p class="card-text">Treasury : {{ token.treasury }}</p>
			<button v-if="!token.kycStatus" class="btn btn-primary" @click="grantKYC">Grant KYC</button>
			<div v-else-if="!isAdmin" >
				<form class="form-inline">
					<div class="form-group mb-2">
						<input type="number" class="form-control" v-model="buyAmount">
					</div>
					<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="buyToken">Buy Token</button>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import { tokenGrantKYC, tokenTransfer } from "@/service/tokenService";
	import { EventBus } from "@/eventBus";

	export default {
		data() {
			return {
				buyAmount: 0
			}
		},
		props: ['token', 'account', 'isAdmin'],
		methods: {
			grantKYC() {
				const instruction = {
					accountId: this.account.accountId,
					tokenId: this.token.tokenId
				}

				tokenGrantKYC(instruction)
						.then(result => {
							console.log('tokenGrantKYC result : ' + result);
							if (result) {
								EventBus.$emit('updateTokenStatus', true);
							}
						})
			},
			buyToken() {
				console.log('buyToken call');
				const tokenId = this.token.tokenId;
				const account = this.$store.getters.getAdmin;
				const quantity = this.buyAmount;
				const hbar = 0;
				const destination = this.account;

				console.log('account : ' + account.accountId);
				console.log('destination : ' + destination.accountId);

				tokenTransfer(tokenId, account, quantity, hbar, destination)
						.then(result => {
							console.log('token transfer result : ' + result);
							if (result) {
								EventBus.$emit('updateTokenStatus', true);
							}
						});
			}
		}
	}
</script>

<style scoped>

</style>